import Assets from '../../services/assets-v2';

export enum assetsActionNames {
  SET_ASSET = 'SET_ASSET',
}

export interface AssetsState {
  selectedAsset: Assets | undefined;
}

interface SetAssetAction {
  type: typeof assetsActionNames.SET_ASSET;
  payload: Assets;
}

export type AssetsActionTypes = SetAssetAction;
